import type { Bonus, CollageItem, FaqItem, Feature, Place, Printable, Step, Testimonial } from '../types/content';
export const productName = 'DAS GROSSE EVANGELISATIONS-PAKET';
export const checkoutUrl = 'https://das-grosse-evangelisations-paket.impultienda.ar/checkout';
export const offerAnchor = '#offer';

/** Finished main product mockup — used once, in the hero. */
export const heroMockup = 'https://cdn.magicpatterns.com/uploads/7bDGKFQmvKwsF92M2PrcSN/Paquete_evangelistico_de_tarjetas_biblicas.png';

/* ---------- Section 2 — Conviction ---------- */
export const hesitations = ['Was soll ich bloß sagen?', 'Und wenn sie mich ablehnen?', 'Ich bin einfach zu schüchtern.', 'Ich kenne die Bibel nicht gut genug.', 'Ich will niemanden in Verlegenheit bringen.', 'Nächstes Mal mache ich es.'];

/* ---------- Section 3 — Solution ---------- */
export const simpleMessages = ['Ein Bibelvers.', 'Eine Botschaft der Hoffnung.', 'Eine Erinnerung an Gottes Liebe.', 'Eine einfache Botschaft, die jemanden zu Jesus führt.'];
export const handoffs = ['jemandem in die Hand drücken kannst …', 'einem Geschenk beilegen kannst …', 'mit einem Kollegen teilen kannst …', 'einem Nachbarn schenken kannst …', 'oder immer dabeihaben kannst, um bereit zu sein, wenn sich eine Gelegenheit ergibt.'];
export const noMores = ['Keine aufwendige Vorbereitung.', 'Du musst nichts mehr selbst gestalten.', 'Du musst nicht mehr warten, bis du dich sicher genug fühlst, um anzufangen.'];

/* ---------- Section 4 — How it works ---------- */
export const steps: Step[] = [{
  title: 'Ausdrucken',
  text: 'Wähle deinen Lieblingsvers oder dein Lieblingsdesign aus und druck es zu Hause oder im Copyshop aus.'
}, {
  title: 'Ausschneiden',
  text: 'Schneide die Karten, kleinen Botschaften oder Druckvorlagen aus, die du weitergeben möchtest.',
  extras: ['Du musst nichts von Grund auf gestalten.', 'Keine komplizierte Einrichtung.', 'Alles ist schon für dich vorbereitet.']
}, {
  title: 'Weitergeben',
  text: 'Hab sie immer dabei und nutze sie, wann immer Gott dir die Gelegenheit schenkt, einen Samen zu säen.',
  extras: ['Eine kleine Botschaft kann jemanden genau in dem Moment erreichen, in dem er sie braucht.']
}];

/* ---------- Section 5 — Material preview ---------- */
const printableAlt = 'Druckfertige Evangeliumskarte mit Bibelvers';
export const printables: Printable[] = [{
  id: 'card-1',
  src: 'https://cdn.magicpatterns.com/uploads/83yJcUZ1ByZaAi29GFpjKY/1img.png',
  alt: printableAlt,
  wide: true
}, {
  id: 'card-2',
  src: 'https://cdn.magicpatterns.com/uploads/c1FWo98nwWky9zuid9TaXh/2img.png',
  alt: printableAlt,
  wide: true
}, {
  id: 'card-3',
  src: 'https://cdn.magicpatterns.com/uploads/2qcVZXkT2P4pz87LpJBQtS/3img.png',
  alt: printableAlt,
  wide: true
}, {
  id: 'card-4',
  src: 'https://cdn.magicpatterns.com/uploads/8KUVsayhACyXns9yrGBBvV/4img.png',
  alt: printableAlt,
  wide: true
}, {
  id: 'card-5',
  src: 'https://cdn.magicpatterns.com/uploads/fngRfrbxQYjckuohbtna4m/5img.png',
  alt: printableAlt,
  wide: true
}, {
  id: 'card-6',
  src: 'https://cdn.magicpatterns.com/uploads/aF23NydyHRKbQnPe5wB8SV/6img.png',
  alt: printableAlt,
  wide: true
}, {
  id: 'card-7',
  src: 'https://cdn.magicpatterns.com/uploads/7UwgQPNBiHLmvo5xqBX1f7/7img.png',
  alt: printableAlt,
  wide: true
}, {
  id: 'card-8',
  src: 'https://cdn.magicpatterns.com/uploads/r2C73q15HbjJr3B2vjMUV9/8img.png',
  alt: printableAlt,
  wide: true
}, {
  id: 'card-9',
  src: 'https://cdn.magicpatterns.com/uploads/81Hj99cf5rm8Nu27QjLxHp/9img.png',
  alt: printableAlt,
  wide: true
}, {
  id: 'card-10',
  src: 'https://cdn.magicpatterns.com/uploads/nwMTXpQUdCsmcZ5FvqzdDS/10img.png',
  alt: printableAlt,
  wide: true
}, {
  id: 'card-11',
  src: 'https://cdn.magicpatterns.com/uploads/uwqBacu15S8dyAmaNzVwze/11img.png',
  alt: printableAlt,
  wide: true
}, {
  id: 'card-12',
  src: 'https://cdn.magicpatterns.com/uploads/k5JGiqjtaAcHipfLmZcyCN/12img.png',
  alt: printableAlt,
  wide: true
}];
export const themes = ['Gottes Liebe', 'Hoffnung', 'Gebet', 'Frieden', 'Erlösung', 'Jesus', 'Das Kreuz', 'Gottes Verheißungen', 'Ermutigung', 'Glaube'];

/* ---------- Section 6 — Everyday evangelism ---------- */
export const places: Place[] = [{
  title: 'Bei der Arbeit',
  text: 'Mit deinen Kollegen oder den Menschen, denen du im Laufe des Tages begegnest.'
}, {
  title: 'In deiner Nachbarschaft',
  text: 'Mit deinen Nachbarn und den Menschen in deinem Viertel.'
}, {
  title: 'Mit deinen Geschenken',
  text: 'Leg einem Geschenk, einem Päckchen oder einer kleinen Aufmerksamkeit eine Evangeliumskarte oder einen Bibelvers bei.'
}, {
  title: 'Mit Freunden und Familie',
  text: 'Teile eine Botschaft, die ganz natürlich die Tür zu einem tieferen Gespräch über Jesus öffnen kann.'
}, {
  title: 'Bei Aktionen deiner Gemeinde',
  text: 'Halte druckfertige biblische Materialien für Evangelisation, Einsätze vor Ort und Gemeindeveranstaltungen bereit.'
}, {
  title: 'Bei Begegnungen im Alltag',
  text: 'Hab immer ein paar Karten dabei: Wenn sich eine Gelegenheit ergibt, hast du schon etwas Wertvolles zum Weitergeben.'
}];

/* ---------- Section 7 — Shyness ---------- */
export const evangelismMyths = ['Menschen, die selbstbewusst predigen können.', 'Menschen, die die Bibel in- und auswendig kennen.', 'Menschen, die von Natur aus extrovertiert sind.', 'Menschen, die immer genau wissen, was sie sagen sollen.'];
export const firstSteps = ['Einen Vers.', 'Eine Botschaft.', 'Eine Erinnerung an Jesu Liebe.'];

/* ---------- Section 8 — What you get ---------- */
export const featureHighlights: (Feature & {
  value: string;
})[] = [{
  value: '200+',
  title: 'Bibelverse, bereit zum Weitergeben',
  text: 'Eine umfangreiche Sammlung biblischer Botschaften – ausgewählt, damit du Gottes Wort, Hoffnung und das Evangelium in alltäglichen Situationen weitergeben kannst.'
}, {
  value: '20+',
  title: 'Verschiedene druckfertige Designs für das Evangelium',
  text: 'Mehr als 20 verschiedene Designs und Formate, damit du Gottes Wort je nach Person, Ort und Anlass auf unterschiedliche Weise weitergeben kannst.'
}];
export const features: Feature[] = [{
  title: 'Viele Themen rund ums Evangelium',
  text: 'Botschaften über Hoffnung, Erlösung, Gebet, Gottes Liebe, Glauben, Ermutigung, Jesus, das Kreuz und vieles mehr.'
}, {
  title: 'Druckfertige PDF-Dateien',
  text: 'Keine Grafiksoftware nötig. Wähle einfach das gewünschte Material aus, druck es aus, schneide es aus und gib es weiter.'
}, {
  title: 'Beliebig oft nachdrucken',
  text: 'Du kannst die gekauften Dateien jederzeit erneut ausdrucken. Wann immer du neue Karten brauchst, druckst du einfach einen neuen Satz aus.'
}, {
  title: 'Sofortiger digitaler Zugang',
  text: 'Kein Versand. Keine Wartezeit. Nach dem Kauf hast du direkt Zugriff auf deine Dateien und kannst noch heute loslegen.'
}, {
  title: 'Kostenlose Updates – lebenslang',
  text: 'Dein Paket wächst weiter. Sobald wir neue Designs zum Weitergeben des Evangeliums erstellen, werden sie automatisch deinem Ordner hinzugefügt –',
  strong: 'ohne Zusatzkosten, ein Leben lang.'
}];

/* ---------- Section 9 — Purpose ---------- */
export const purposeUses = ['Um ausgedruckt zu werden.', 'Um immer dabei zu sein.', 'Um weitergegeben zu werden.'];
export const peopleNeeds = ['Ein Wort der Hoffnung.', 'Die Erinnerung, dass Gott sie sieht.', 'Einen Bibelvers.', 'Eine Einladung in den Gottesdienst.', 'Oder einfach jemanden, der bereit ist, den ersten Samen zu säen.'];

/* ---------- Section 10 — Bonuses ---------- */
export const bonuses: Bonus[] = [{
  number: 1,
  name: "50 GESPRÄCHSEINSTIEGE ÜBER JESUS",
  lead: 'Du weißt nicht, was du sagen sollst, wenn jemand Interesse zeigt?',
  body: 'Mit diesen einfachen Gesprächseinstiegen lenkst du ein alltägliches Gespräch ganz natürlich auf den Glauben, auf Jesus und auf das Evangelium.',
  coverImage: 'https://cdn.magicpatterns.com/uploads/6P4X22AigX2mjRazn26LtS/BONO1ALEMAN.png'
}, {
  number: 2,
  name: "GEBETSLEITFADEN NACH DEM GESPRÄCH ÜBER JESUS",
  lead: 'Du hast den Samen gesät. Jetzt bete dafür.',
  body: 'Mit diesem einfachen Gebetsleitfaden betest du für die Menschen, denen du begegnest, für die Botschaften, die du weitergibst, und für die Samen, die du gesät hast.',
  coverImage: 'https://cdn.magicpatterns.com/uploads/dkqFieRYPdug4WiGW5fPB4/BONO2ALEMAN.png'
}, {
  number: 3,
  name: "EINLADUNGSKARTEN FÜR DEINE GEMEINDE",
  lead: 'Fertige Einladungen zum Ausdrucken, mit denen du jemandem einen ganz einfachen nächsten Schritt anbietest: in den Gottesdienst zu kommen.',
  body: 'Ideal, um Freunde, Nachbarn, Kollegen und Menschen einzuladen, denen du bei euren Evangelisationsaktionen begegnest.',
  coverImage: 'https://cdn.magicpatterns.com/uploads/qZM2xaSGSSHJ76H74UrVQG/BONO3ALEMAN.png'
}, {
  number: 4,
  name: 'WELCHER BIBELVERS PASST?',
  lead: 'Du fragst dich, welche Botschaft gerade passt?',
  body: 'Mit diesem kompakten Nachschlage-Leitfaden findest du schnell die passende Botschaft für das, was dein Gegenüber gerade durchmacht – Hoffnung, Angst, Entmutigung, Gebet, Gottes Liebe, Erlösung und vieles mehr.',
  coverImage: 'https://cdn.magicpatterns.com/uploads/soL4KX3qLVDfhsorRqV1aN/BONO4ALEMAN.png'
}, {
  number: 5,
  name: "30-TAGE-PLAN: DAS EVANGELIUM WEITERGEBEN",
  lead: 'Mach Evangelisation von etwas, das du ständig aufschiebst, zu etwas, das du bewusst lebst.',
  body: 'Eine einfache 30-Tage-Challenge, die dich ermutigt, nach Gelegenheiten Ausschau zu halten, Samen zu säen und das Weitergeben des Evangeliums zu einem festen Teil deines Alltags als Christ zu machen.',
  coverImage: 'https://cdn.magicpatterns.com/uploads/a6n1xtHAxiDQTmJe6MAZNw/BONO5ALEMAN.png'
}];

/* ---------- Section 11 — Reframe ---------- */
export const ordinaryPlaces = [{
  place: 'Der Supermarkt',
  rest: 'ist nicht mehr nur der Supermarkt.'
}, {
  place: 'Dein Arbeitsplatz',
  rest: 'ist nicht mehr nur dein Arbeitsplatz.'
}, {
  place: 'Deine Nachbarschaft',
  rest: 'ist nicht mehr nur der Ort, an dem du wohnst.'
}];
export const someoneMay = ['Vielleicht betet gerade jemand um neue Hoffnung.', 'Vielleicht fühlt sich jemand vergessen.', 'Vielleicht sucht jemand nach Gott.', 'Vielleicht muss jemand gerade jetzt von Jesus hören.'];

/* ---------- Section 12 — Social proof ---------- */
export const testimonials: Testimonial[] = [{
  headline: 'Endlich zerbreche ich mir nicht mehr den Kopf darüber, wie ich anfangen soll.',
  quote: 'Ich wollte meinen Glauben öfter teilen, aber ich war jedes Mal wie blockiert, weil ich nicht wusste, was ich sagen sollte. Dass die Botschaften schon fertig vorbereitet sind, hat mir diesen ersten Schritt wirklich leichter gemacht. Ich habe ein paar davon ausgedruckt, in meine Handtasche gesteckt – und jetzt halte ich richtig Ausschau nach Gelegenheiten, sie weiterzugeben.',
  name: "Anna M.",
  role: 'Christliche Mutter'
}, {
  headline: 'Jetzt habe ich immer etwas zum Weitergeben dabei.',
  quote: 'Ich habe mehrere Designs ausgedruckt und habe einen kleinen Stapel im Auto und einen in meiner Tasche. Ich finde es schön zu wissen: Wenn ich jemandem begegne, der Ermutigung braucht, habe ich schon einen Bibelvers parat, den ich ihm schenken kann. Es ist so ein einfacher Weg, Gottes Wort bewusster weiterzugeben.',
  name: "Katharina T.",
  role: 'Gemeindemitglied'
}, {
  headline: 'Wir nutzen sie für Evangelisation und für unsere Geschenke.',
  quote: 'Für die Evangelisationsaktionen unserer Gemeinde waren sie unglaublich hilfreich. Wir haben sie kleinen Geschenken beigelegt, bei Aktionen in der Nachbarschaft verteilt und an Besucher weitergegeben. So können wir ganz einfach eine bedeutungsvolle Botschaft des Evangeliums mitgeben, ohne alles selbst gestalten zu müssen.',
  name: "Markus R.",
  role: 'Ehrenamtlicher in der Gemeindearbeit'
}, {
  headline: 'Es gibt immer eine Botschaft, die zum Moment passt.',
  quote: 'Am meisten hat mich die Vielfalt überrascht. Mit über 200 Bibelversen und mehr als 20 verschiedenen Designs gebe ich nicht jedem genau dieselbe Botschaft. Je nach Person und Situation kann ich etwas über Hoffnung, Gebet, Gottes Liebe, Glauben oder Erlösung auswählen.',
  name: "Sabine A.",
  role: 'Leiterin der Frauenarbeit'
}];

/* ---------- Section 13 — Transition ---------- */
export const noNeeds = ['Du musst nicht über Nacht zum Straßenprediger werden.', 'Du musst keine perfekte Ansprache auswendig lernen.', 'Du musst nicht auf alles eine Antwort haben.'];
export const oneSeed = ['Ein Vers.', 'Eine Botschaft.', 'Ein Mensch.', 'Ein Samenkorn.'];

/* ---------- Section 14 — Complete offer ---------- */
export const offerIncludes = ['Über 200 Bibelverse, bereit zum Weitergeben', 'Mehr als 20 verschiedene druckfertige Designs für das Evangelium', 'Botschaften über Hoffnung, Erlösung, Gebet, Gottes Liebe, Glauben, Jesus und vieles mehr', 'Druckfertige PDF-Dateien', 'Beliebig oft nachdruckbar – wann immer du sie brauchst', 'Sofortiger digitaler Zugang', 'Kostenlose Updates – lebenslang, neue Designs kommen laufend hinzu'];

/** Real printables used in the offer collage. */
export const collagePrintables: CollageItem[] = [{
  src: 'https://cdn.magicpatterns.com/uploads/83yJcUZ1ByZaAi29GFpjKY/1img.png',
  alt: printableAlt
}, {
  src: 'https://cdn.magicpatterns.com/uploads/c1FWo98nwWky9zuid9TaXh/2img.png',
  alt: printableAlt
}, {
  src: 'https://cdn.magicpatterns.com/uploads/2qcVZXkT2P4pz87LpJBQtS/3img.png',
  alt: printableAlt
}, {
  src: 'https://cdn.magicpatterns.com/uploads/8KUVsayhACyXns9yrGBBvV/4img.png',
  alt: printableAlt
}, {
  src: 'https://cdn.magicpatterns.com/uploads/fngRfrbxQYjckuohbtna4m/5img.png',
  alt: printableAlt
}, {
  src: 'https://cdn.magicpatterns.com/uploads/aF23NydyHRKbQnPe5wB8SV/6img.png',
  alt: printableAlt
}, {
  src: 'https://cdn.magicpatterns.com/uploads/7UwgQPNBiHLmvo5xqBX1f7/7img.png',
  alt: printableAlt
}, {
  src: 'https://cdn.magicpatterns.com/uploads/r2C73q15HbjJr3B2vjMUV9/8img.png',
  alt: printableAlt
}, {
  src: 'https://cdn.magicpatterns.com/uploads/81Hj99cf5rm8Nu27QjLxHp/9img.png',
  alt: printableAlt
}];

/* ---------- Section 16 — FAQ ---------- */
export const faqs: FaqItem[] = [{
  question: 'Ist das ein physisches Produkt?',
  answer: 'Nein.\n\nEs handelt sich um ein 100 % digitales Produkt. Du erhältst PDF-Dateien, die du herunterladen und selbst ausdrucken kannst.'
}, {
  question: 'Wie erhalte ich das Paket?',
  answer: 'Direkt nach Abschluss deines Kaufs erhältst du sofortigen digitalen Zugang zu deinen Materialien.\n\nEs erfolgt kein physischer Versand.'
}, {
  question: 'Was genau ist im Paket enthalten?',
  answer: 'Du erhältst über 200 Bibelverse auf mehr als 20 verschiedenen druckfertigen Designs zum Weitergeben des Evangeliums – plus die 5 enthaltenen Bonusmaterialien.'
}, {
  question: 'Sind die Dateien druckfertig?',
  answer: 'Ja.\n\nDie Materialien sind bereits fertig gestaltet und als PDF vorbereitet: Du musst sie nur ausdrucken, ausschneiden und kannst sofort mit dem Weitergeben beginnen.'
}, {
  question: 'Kann ich die Designs bearbeiten?',
  answer: 'Nein.\n\nDie Designs sind nicht bearbeitbar. Sie werden fertig gestaltet und druckbereit geliefert, damit du keine Zeit mit Gestalten oder Anpassen verlierst.'
}, {
  question: 'Kann ich sie mehrmals ausdrucken?',
  answer: 'Ja.\n\nSobald du deine Dateien erhalten hast, kannst du jederzeit neue Exemplare ausdrucken – für dein persönliches Weitergeben des Evangeliums und für die erlaubte Nutzung im Rahmen der Gemeindearbeit.'
}, {
  question: 'Brauche ich eine spezielle Software?',
  answer: 'Nein.\n\nDu brauchst nur ein Gerät, das PDF-Dateien öffnen kann, und Zugang zu einem Drucker oder Copyshop.'
}, {
  question: 'Ist das nur etwas für Pastoren oder Gemeindeleiter?',
  answer: 'Nein.\n\nDAS GROSSE EVANGELISATIONS-PAKET wurde für ganz normale Christen entwickelt, die einen einfachen Weg suchen, ihren Glauben weiterzugeben. Du musst weder Pastor noch Missionar oder erfahrener Evangelist sein.'
}, {
  question: 'Was, wenn ich schüchtern bin oder beim Evangelisieren nervös werde?',
  answer: 'Genau dann können dir diese Materialien eine große Hilfe sein.\n\nDu musst nicht mit einem langen Gespräch anfangen und nicht genau wissen, was du sagen sollst. Fang klein an. Teile einen Vers. Schenk jemandem eine Botschaft des Evangeliums. Säe einen Samen.'
}, {
  question: 'Können Gemeinden die Materialien für Evangelisation nutzen?',
  answer: 'Die Materialien eignen sich für persönliche Evangelisation, Aktivitäten in der Gemeindearbeit und Einsätze vor Ort – im Rahmen der Nutzungsrechte, die mit deinem Kauf verbunden sind.'
}, {
  question: 'Welche Verse und Botschaften sind enthalten?',
  answer: 'Du findest biblische Botschaften rund um Jesus, Erlösung, Gottes Liebe, Hoffnung, Gebet, Frieden, Ermutigung, Glauben, Gottes Verheißungen, das Kreuz und vieles mehr.\n\nMit über 200 Bibelversen und mehr als 20 verschiedenen Designs hast du abwechslungsreiche Botschaften für unterschiedliche Menschen und Situationen.'
}, {
  question: 'Gibt es eine Garantie?',
  answer: 'Ja.\n\nDein Kauf ist durch eine 7-Tage-Garantie geschützt.'
}, {
  question: 'Erhalte ich auch zukünftige Designs?',
  answer: 'Ja. Sobald wir neue Designs zum Weitergeben des Evangeliums erstellen, werden sie automatisch deinem Ordner hinzugefügt. Wenn du das Paket bereits gekauft hast, sind diese künftigen Updates kostenlos und lebenslang inklusive.'
}];

/* ---------- Section 17 — Final close ---------- */
export const alreadyGo = ['Du gehst sowieso in den Supermarkt.', 'Du gehst sowieso zur Arbeit.', 'Du begegnest sowieso deinen Nachbarn.', 'Du triffst sowieso Menschen.'];